import {createGlobalStyle} from "styled-components";

const FooterStyle = createGlobalStyle`
    .footer{
        border-top: 0.5px solid #fff;
        padding: 10px 0;
        margin-top: 45px;
    }
    .footer img{
        width: 20px;
        margin-right: 10px
    }
`;

export default FooterStyle;
